import { basicTheme } from '../theme';
import { givingColor } from './color';
export const GivingTheme = { ...basicTheme,

  /**
   * @deprecated use colors
   */
  COLORS_BASIC: givingColor.COLORS_BASIC,

  /**
   * @deprecated use colors
   */
  COLORS: givingColor.COLORS,
  colors: givingColor.colors
};